module.exports = __webpack_public_path__ + "static/media/multiple-roles-logo.3195501c.png";